import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

const useStyles = createMemoStyles(({ spacing }: HeaderTheme) => ({
  title: {
    padding: [0, spacing[4], 0, spacing[3]],
  },
}));

export default useStyles;
